/* ============
 * Getters for the global module
 * ============
 *
 * The getters that are available on the
 * global module.
 */
export const users = (state) => {
  return state.users
}
export const total = (state) => {
  return state.total
}
export const offset = (state) => {
  return state.offset
}
export const max = (state) => {
  return state.max
}
export const getUserById = (state) => (id) => {
  return state.users.find(user => user.id === id)
}
export const sort = (state) => {
  return state.sort
}
export const order = (state) => {
  return state.order
}
export default {
  users,
  total,
  offset,
  max,
  getUserById,
  sort,
  order,
}
